import http from './http';
import notifier from '../_utils/notifier';

const collectionAPI = {
  getArrangements(authorSlug=null, tagSlug=null) {
    let config = null;
    if (authorSlug){
      config = { params: { author: authorSlug } }
    }
    if (tagSlug){
      config = { params: { tag: tagSlug } }
    }
    return http.get('collection/', config)
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  deleteFromArrangements(ids){
    return http.delete('collection/',  { params: { offers: ids } })
    .then(
      function(success) { return 'ok' },
      function(error) {
        notifier.alert(gettext('При удалении аранжировок произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getPlaylists() {
    return http.get('collection-playlists/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getArrangementPlaylists(offer) {
    return http.get('collection-playlists/arrangement/', { params: {offer: offer}})
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  checkUncheckPlaylist(payload){
    const { checked, ...data } = {...payload};
    const url = 'collection-playlists-items/';
    if (checked){
      return http.post(url,{ ...data })
      .then(
        function(success) { return success },
        function(error) {
          if (error.status !== 400) {
            notifier.alert(gettext('При сохранении данных произошла ошибка.') + '<br>' + error.messages);
          }
        }
      )
    } else {
      return http.delete(url,  { params: data })
      .then(
        function(success) { return 'ok' },
        function(error) {
          notifier.alert(gettext('При сохранении данных произошла ошибка.') + '<br>' + error.messages);
        }
      )
    }

  },
  createPlaylist(payload){
    return http.post('collection-playlists/',{ ...payload })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При создании плейлиста произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getPlaylist(id){
    return http.get('collection-playlists/'+ id + '/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  deletePlaylist(id){
    return http.delete('collection-playlists/'+ id + '/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При удалении данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  updatePlaylist(id, payload){
    return http.patch('collection-playlists/' + id +'/', { ...payload })
    .then(
      function(success) { return success; },
      function(error) {
        notifier.alert(gettext('При сохранении данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getPlaylistArrangements(id) {
    return http.get('collection-playlists-items/', { params: { playlist: id } })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getAuthors(){
    return http.get('collection/authors/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getGenres(){
    return http.get('collection/genres/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
  getGenre(slug){
    return http.get('collection/genres/'+ slug + '/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке данных произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },
}


export default collectionAPI;

